module.exports = __webpack_public_path__ + "static/img/d1.88c3a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/precision/d1.jpg
// module id = TAP6
// module chunks = 0